export { LegendTabs } from './LegendTabs.component';
